import React from 'react'
import { Modal } from './Modal'
import { ChangePasswordForm } from '../Form/ChangePasswordForm'

const ChangePasswordModal = () => (
  <Modal showLogo>
    <ChangePasswordForm />
  </Modal>
)

export { ChangePasswordModal }
